import type { ValueOf } from './util/typeUtils';

export const NOTE_CHANGE_TYPE = {
    applicant: 'applicant',
    notes: 'notes',
} as const;

/** Which kind of note is favored (lead notes list UI & sort key) */
export const FAVORED_NOTE_TYPE = {
    APPLICANT: NOTE_CHANGE_TYPE.applicant,
    REGULAR: 'regular',
    SYSTEM: 'system',
} as const;

export type FAVORED_NOTE_TYPE_VALUE = ValueOf<typeof FAVORED_NOTE_TYPE>;
